import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import Chart from 'chart.js/auto';
import { ToastrService } from 'ngx-toastr';
import { fadeIn, fadeOut } from 'src/app/animations';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-simulador-plano-familia',
  templateUrl: './simulador-plano-familia.component.html',
  styleUrls: ['./simulador-plano-familia.component.css'],
  animations: [fadeIn, fadeOut]
})
export class SimuladorPlanoFamiliaComponent {
  loading: boolean = false;
  chartAcumulado: any;
  chartFinal: any;
  montanteAcumulado = 0;
  pagamentosAnuais = 12;
  saqueInicial = 0;
  tabuaAtuaria = 0;
  simulacao = false;
  formaRecebimento: any = '2';
  taxaJurosAnual: number = 6;
  percentualSaldo: number = 1.5;
  idadeAposentadoria: number = 0;
  idadeAtual: number = 0;
  simulacaoCoberturaInvalidez: number = 0;
  simulacaoCoberturaMorte: number = 0;
  limiteInvalidez: { maxima: number; minima: number } = { maxima: 0, minima: 0 };
  limiteMorte: { maxima: number; minima: number } = { maxima: 0, minima: 0 };
  numeroAnos: any = 5;
  totalRisco: number = 0;
  rendaRiscoPrevidencia: number = 0;
  rendaRiscoInvalidez: number = 0;
  rendaRiscoMorte: number = 0;
  tempo: number = 0;
  jurosCompostoMain: number = 0;
  taxa: any = null;
  sexo: any = 'AT2000M';
  resultadoBeneficioDeterminado: number = 0;
  resultadoBeneficioIndeterminado: number = 0;
  resultadoPercentualSaldoConta: number = 0;
  // Valores Em Tela
  investimentoMensalPrevidencia: number = 0;
  investimentoMensalInvalidez: number = 0;
  investimentoMensalMorte: number = 0;
  valorBruto = 0;
  valorTotal = 0;
  valorRendimentos = 0;
  auxInvestimentoMensal: number = 0;
  auxInvestimentoPrevidencia: number = 0;
  auxInvestimentoInvalidez: number = 0;
  auxInvestimentoMorte: number = 0;
  checkboxRiscoInvalidez: boolean = true;
  checkboxRiscoMorte: boolean = true;
  planos = [
    { faixaEtaria: [14, 35], morte: 0.1131, ip: 0.1304 },
    { faixaEtaria: [36, 40], morte: 0.1884, ip: 0.1666 },
    { faixaEtaria: [41, 45], morte: 0.2913, ip: 0.2144 },
    { faixaEtaria: [46, 50], morte: 0.4834, ip: 0.3095 },
    { faixaEtaria: [51, 55], morte: 0.7501, ip: 0.4948 },
    { faixaEtaria: [56, 60], morte: 1.0757, ip: 0.8528 },
    { faixaEtaria: [61, 65], morte: 1.6106, ip: 1.5411 },
    { faixaEtaria: [66], morte: 2.1531, ip: 2.2291 },
    { faixaEtaria: [67], morte: 2.3749, ip: 2.5247 },
    { faixaEtaria: [68], morte: 2.6172, ip: 2.8615 },
    { faixaEtaria: [69], morte: 2.8863, ip: 3.2451 },
    { faixaEtaria: [70], morte: 3.1842, ip: 3.6821 },
    { faixaEtaria: [71], morte: 3.5179, ip: 4.1794 },
    { faixaEtaria: [72], morte: 3.8905, ip: 4.746 },
    { faixaEtaria: [73], morte: 4.3087, ip: 5.3911 },
    { faixaEtaria: [74], morte: 4.7755, ip: 6.1255 },
    { faixaEtaria: [75], morte: 5.2997, ip: 6.9619 }
  ];
  tabelaAtuaria = [
    { idade: 0, AT2000M: 1042, AT2000F: 1098 },
    { idade: 1, AT2000M: 1032, AT2000F: 1087 },
    { idade: 2, AT2000M: 1020, AT2000F: 1075 },
    { idade: 3, AT2000M: 1007, AT2000F: 1062 },
    { idade: 4, AT2000M: 995, AT2000F: 1049 },
    { idade: 5, AT2000M: 982, AT2000F: 1037 },
    { idade: 6, AT2000M: 969, AT2000F: 1024 },
    { idade: 7, AT2000M: 957, AT2000F: 1011 },
    { idade: 8, AT2000M: 944, AT2000F: 998 },
    { idade: 9, AT2000M: 931, AT2000F: 985 },
    { idade: 10, AT2000M: 919, AT2000F: 972 },
    { idade: 11, AT2000M: 906, AT2000F: 959 },
    { idade: 12, AT2000M: 893, AT2000F: 947 },
    { idade: 13, AT2000M: 881, AT2000F: 934 },
    { idade: 14, AT2000M: 868, AT2000F: 921 },
    { idade: 15, AT2000M: 855, AT2000F: 908 },
    { idade: 16, AT2000M: 843, AT2000F: 895 },
    { idade: 17, AT2000M: 830, AT2000F: 882 },
    { idade: 18, AT2000M: 818, AT2000F: 870 },
    { idade: 19, AT2000M: 805, AT2000F: 857 },
    { idade: 20, AT2000M: 792, AT2000F: 844 },
    { idade: 21, AT2000M: 780, AT2000F: 831 },
    { idade: 22, AT2000M: 767, AT2000F: 818 },
    { idade: 23, AT2000M: 755, AT2000F: 806 },
    { idade: 24, AT2000M: 742, AT2000F: 793 },
    { idade: 25, AT2000M: 730, AT2000F: 780 },
    { idade: 26, AT2000M: 717, AT2000F: 768 },
    { idade: 27, AT2000M: 705, AT2000F: 755 },
    { idade: 28, AT2000M: 692, AT2000F: 742 },
    { idade: 29, AT2000M: 680, AT2000F: 729 },
    { idade: 30, AT2000M: 667, AT2000F: 717 },
    { idade: 31, AT2000M: 655, AT2000F: 704 },
    { idade: 32, AT2000M: 642, AT2000F: 691 },
    { idade: 33, AT2000M: 630, AT2000F: 679 },
    { idade: 34, AT2000M: 617, AT2000F: 666 },
    { idade: 35, AT2000M: 605, AT2000F: 653 },
    { idade: 36, AT2000M: 592, AT2000F: 641 },
    { idade: 37, AT2000M: 580, AT2000F: 628 },
    { idade: 38, AT2000M: 567, AT2000F: 615 },
    { idade: 39, AT2000M: 555, AT2000F: 603 },
    { idade: 40, AT2000M: 542, AT2000F: 590 },
    { idade: 41, AT2000M: 530, AT2000F: 577 },
    { idade: 42, AT2000M: 517, AT2000F: 565 },
    { idade: 43, AT2000M: 505, AT2000F: 552 },
    { idade: 44, AT2000M: 493, AT2000F: 540 },
    { idade: 45, AT2000M: 481, AT2000F: 527 },
    { idade: 46, AT2000M: 468, AT2000F: 515 },
    { idade: 47, AT2000M: 456, AT2000F: 502 },
    { idade: 48, AT2000M: 445, AT2000F: 490 },
    { idade: 49, AT2000M: 433, AT2000F: 478 },
    { idade: 50, AT2000M: 421, AT2000F: 465 },
    { idade: 51, AT2000M: 409, AT2000F: 453 },
    { idade: 52, AT2000M: 398, AT2000F: 441 },
    { idade: 53, AT2000M: 386, AT2000F: 429 },
    { idade: 54, AT2000M: 375, AT2000F: 417 },
    { idade: 55, AT2000M: 364, AT2000F: 405 },
    { idade: 56, AT2000M: 353, AT2000F: 393 },
    { idade: 57, AT2000M: 341, AT2000F: 381 },
    { idade: 58, AT2000M: 330, AT2000F: 369 },
    { idade: 59, AT2000M: 319, AT2000F: 358 },
    { idade: 60, AT2000M: 308, AT2000F: 346 },
    { idade: 61, AT2000M: 298, AT2000F: 334 },
    { idade: 62, AT2000M: 287, AT2000F: 323 },
    { idade: 63, AT2000M: 276, AT2000F: 312 },
    { idade: 64, AT2000M: 266, AT2000F: 300 },
    { idade: 65, AT2000M: 255, AT2000F: 289 },
    { idade: 66, AT2000M: 245, AT2000F: 278 },
    { idade: 67, AT2000M: 235, AT2000F: 267 },
    { idade: 68, AT2000M: 225, AT2000F: 256 },
    { idade: 69, AT2000M: 215, AT2000F: 246 },
    { idade: 70, AT2000M: 206, AT2000F: 235 },
    { idade: 71, AT2000M: 197, AT2000F: 225 },
    { idade: 72, AT2000M: 188, AT2000F: 214 },
    { idade: 73, AT2000M: 179, AT2000F: 204 },
    { idade: 74, AT2000M: 170, AT2000F: 194 },
    { idade: 75, AT2000M: 162, AT2000F: 185 },
    { idade: 76, AT2000M: 154, AT2000F: 175 },
    { idade: 77, AT2000M: 146, AT2000F: 166 },
    { idade: 78, AT2000M: 139, AT2000F: 157 },
    { idade: 79, AT2000M: 132, AT2000F: 148 },
    { idade: 80, AT2000M: 125, AT2000F: 140 },
    { idade: 81, AT2000M: 118, AT2000F: 132 },
    { idade: 82, AT2000M: 112, AT2000F: 124 },
    { idade: 83, AT2000M: 106, AT2000F: 116 },
    { idade: 84, AT2000M: 100, AT2000F: 109 },
    { idade: 85, AT2000M: 94, AT2000F: 102 },
    { idade: 86, AT2000M: 89, AT2000F: 96 },
    { idade: 87, AT2000M: 84, AT2000F: 89 },
    { idade: 88, AT2000M: 79, AT2000F: 84 },
    { idade: 89, AT2000M: 74, AT2000F: 78 },
    { idade: 90, AT2000M: 70, AT2000F: 73 },
    { idade: 91, AT2000M: 66, AT2000F: 69 },
    { idade: 92, AT2000M: 62, AT2000F: 65 },
    { idade: 93, AT2000M: 59, AT2000F: 61 },
    { idade: 94, AT2000M: 55, AT2000F: 57 },
    { idade: 95, AT2000M: 52, AT2000F: 54 },
    { idade: 96, AT2000M: 49, AT2000F: 51 },
    { idade: 97, AT2000M: 46, AT2000F: 48 },
    { idade: 98, AT2000M: 43, AT2000F: 45 },
    { idade: 99, AT2000M: 40, AT2000F: 42 },
    { idade: 100, AT2000M: 37, AT2000F: 39 },
    { idade: 101, AT2000M: 34, AT2000F: 36 },
    { idade: 102, AT2000M: 32, AT2000F: 33 },
    { idade: 103, AT2000M: 29, AT2000F: 31 },
    { idade: 104, AT2000M: 26, AT2000F: 28 },
    { idade: 105, AT2000M: 24, AT2000F: 25 },
    { idade: 106, AT2000M: 21, AT2000F: 22 },
    { idade: 107, AT2000M: 19, AT2000F: 20 },
    { idade: 108, AT2000M: 17, AT2000F: 18 },
    { idade: 109, AT2000M: 15, AT2000F: 15 },
    { idade: 110, AT2000M: 13, AT2000F: 13 },
    { idade: 111, AT2000M: 11, AT2000F: 11 },
    { idade: 112, AT2000M: 9, AT2000F: 10 },
    { idade: 113, AT2000M: 8, AT2000F: 8 },
    { idade: 114, AT2000M: 7, AT2000F: 7 },
    { idade: 115, AT2000M: 5, AT2000F: 5 },
    { idade: 116, AT2000M: 5, AT2000F: 5 },
    { idade: 117, AT2000M: 5, AT2000F: 5 },
    { idade: 118, AT2000M: 5, AT2000F: 5 },
    { idade: 119, AT2000M: 5, AT2000F: 5 },
    { idade: 120, AT2000M: 7, AT2000F: 7 }
  ];
  sexos: any = [{ chave: 'Masculino', valor: 'AT2000M' }, { chave: 'Feminino', valor: 'AT2000F' }];
  listaPercentual = Array.from({ length: 15 }, (_, i) => ({
    chave: `${(i + 1) / 10}`.replace('.', ',') + '%',
    valor: (i + 1) / 10
  }));
  listaTaxa = Array.from({ length: 12 }, (_, i) => ({
    chave: `${i + 1}%`,
    valor: i + 1
  }));
  listaAnos = Array.from({ length: 46 }, (_, i: any = 5) => ({
    chave: `${i + 5} anos`,
    valor: i + 5
  }))
  formData: FormGroup = new FormGroup({
    contribuicaoMensal: new FormControl(100, [Validators.required]),
    idadeAposentadoria: new FormControl(null, [Validators.required]),
    dataNascimento: new FormControl(null, [Validators.required]),
    taxaJurosAnual: new FormControl(6),
    aporteInicial: new FormControl(0),
    portabilidade: new FormControl(0),
    prazoAnos: new FormControl(5),
    sexo: new FormControl('AT2000M'),
  });
  constructor(private toast: ToastrService, private router: Router) { }
  calcularData(): any {
    const dataNascimento = new Date(this.formData.get('dataNascimento')?.value);
    const dataAposentadoria = new Date(this.formData.get('dataNascimento')?.value);
    dataAposentadoria.setFullYear(dataNascimento.getFullYear() + parseInt(this.formData.get('idadeAposentadoria')?.value));
    this.idadeAtual = this.formData.get('dataNascimento')?.value.slice(-2) != '01'
      ? ((new Date().getFullYear() - dataNascimento.getFullYear()) * 12) + (Math.abs(new Date().getMonth() - dataNascimento.getMonth()))
      : ((new Date().getFullYear() - dataNascimento.getFullYear()) * 12) + (Math.abs(new Date().getMonth() - dataNascimento.getMonth())) - 1;
    this.idadeAposentadoria = this.formData.get('dataNascimento')?.value.slice(-2) != '01'
      ? ((dataAposentadoria.getFullYear() - dataNascimento.getFullYear()) * 12) + dataAposentadoria.getMonth()
      : ((dataAposentadoria.getFullYear() - dataNascimento.getFullYear()) * 12) + dataAposentadoria.getMonth() - 1;
    if (this.tempo == this.idadeAposentadoria - this.idadeAtual) {
      return;
    }
    this.tempo = this.idadeAposentadoria - this.idadeAtual - 2;
  }
  alterarRiscoMorte(prop: any) {
    if (!this.checkboxRiscoMorte) {
      this.investimentoMensalMorte = 0;
    } else {
      this.investimentoMensalMorte = this.formData.get('contribuicaoMensal')?.value * 0.15;
    }
    this.investimentoMensalPrevidencia = this.formData.get('contribuicaoMensal')?.value - this.investimentoMensalInvalidez - this.investimentoMensalMorte;
    this.simular();
  }
  alterarRiscoInvalidez(prop: any) {
    if (!this.checkboxRiscoInvalidez) {
      this.investimentoMensalInvalidez = 0;
    } else {
      this.investimentoMensalInvalidez = this.formData.get('contribuicaoMensal')?.value * 0.1;
    }
    this.investimentoMensalPrevidencia = this.formData.get('contribuicaoMensal')?.value - this.investimentoMensalInvalidez - this.investimentoMensalMorte;
    this.simular();
  }
  consultaTaxa(prop: any): any {
    const taxas = this.planos.find((x: any) => {
      if (x.faixaEtaria.length > 1 && prop <= 65) {
        const [minIdade, maxIdade] = x.faixaEtaria;
        return prop >= minIdade && prop <= maxIdade;
      }
      return prop >= x.faixaEtaria[0];
    });
    return taxas ? [taxas.morte, taxas.ip] : null;
  }
  formatarValor(valor: any): any {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(valor);
  }
  valorMaximoRisco() {
    let checkbox = document.querySelector('#simulacaoAvancada') as HTMLInputElement;
    let [taxaMorte, taxaInvalidez] = this.consultaTaxa(new Date().getFullYear() - new Date(this.formData.get('dataNascimento')?.value).getFullYear());
    let valorMaximo = this.simulacaoCoberturaInvalidez > this.simulacaoCoberturaMorte ? ((3000 * taxaInvalidez) * 100) / 10 : ((3000 * taxaMorte) * 100) / 15;
    let valorMinimo = this.simulacaoCoberturaInvalidez < this.simulacaoCoberturaMorte ? 200 * taxaInvalidez : 200 * taxaMorte;
  }
  calculoValorMinimo() {
    let [taxaMorte, taxaInvalidez] = this.consultaTaxa(new Date().getFullYear() - new Date(this.formData.get('dataNascimento')?.value).getFullYear());
    this.investimentoMensalInvalidez = 20 * taxaInvalidez;
    this.investimentoMensalMorte = 20 * taxaMorte;
    this.changeRisco();
  }
  riscoMinimo() {
    Swal.fire({
      title: 'Atenção!',
      html: `Ao continuar, o sistema vai calcular automaticamente o valor do investimento mensal <b>mínimo</b> para aderir a cobertura de risco por invalidez e morte
            <ol style="list-style: disc; text-align: justify; margin-left: 2rem; margin-top: 1rem;">
              <li>Benefício mínimo de: R$20.000,00</li>
              <li>Benefício máximo de: R$3.000.000,00</li>            
            </ol>`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: "Continuar",
      cancelButtonText: "Cancelar",
      reverseButtons: true,
      confirmButtonColor: '#1A428A',
    }).then(
      (result: any) => {
        if (result.isConfirmed) {
          this.calculoValorMinimo();
        }
      }
    )
  }
  calcularRiscos() {
    if (this.formaRecebimento == 2) {
      this.rendaRiscoInvalidez = this.simulacaoCoberturaInvalidez / ((this.numeroAnos * 12) + this.numeroAnos);
      this.rendaRiscoMorte = this.simulacaoCoberturaMorte / ((this.numeroAnos * 12) + this.numeroAnos);
    } else if (this.formaRecebimento == 1) {
      this.rendaRiscoInvalidez = this.simulacaoCoberturaInvalidez * (this.percentualSaldo / 100);
      this.rendaRiscoMorte = this.simulacaoCoberturaMorte * (this.percentualSaldo / 100);
    } else {
      this.rendaRiscoInvalidez = this.simulacaoCoberturaInvalidez / this.tabuaAtuaria;
      this.rendaRiscoMorte = this.simulacaoCoberturaMorte / this.tabuaAtuaria;
    }
  }
  changeRisco(prop?: any) {
    let [morte, ip] = this.consultaTaxa(new Date().getFullYear() - new Date(this.formData.get('dataNascimento')?.value).getFullYear());
    this.limiteInvalidez.maxima = ((3000 * ip) * 10) / 10;
    this.limiteInvalidez.minima = 20 * ip;
    this.limiteMorte.maxima = ((3000 * morte) * 10) / 15;
    this.limiteMorte.minima = 20 * morte;
    this.simulacaoCoberturaInvalidez = parseFloat(((this.investimentoMensalInvalidez / ip) * 1000).toFixed(2));
    this.simulacaoCoberturaMorte = parseFloat(((this.investimentoMensalMorte / morte) * 1000).toFixed(2));
    this.calcularRiscos();
    if (this.simulacaoCoberturaMorte > 3000000 || this.simulacaoCoberturaInvalidez < 20000) {
      this.valorMaximoRisco();
    }
  }
  changeMorte() {
    if (this.simulacaoCoberturaMorte > this.totalRisco) {
    }
  }
  simulacaoAvancada(event: any) {
    this.simulacao = !this.simulacao;
  }
  alterarPercentual(prop: any) {
    this.formaRecebimento = prop;
    this.simulacaoParalela();
  }
  getTaxaJuros() {
    let taxaGestao = 0.01;
    return ((1 + (this.taxaJurosAnual / 100)) / (1 + taxaGestao)) ** (1 / 12) - 1;
  }
  calcularPrazoDeterminado(): any {
    let quantidadeMeses = this.pagamentosAnuais * this.numeroAnos;
    let resultado = ((this.investimentoMensalPrevidencia * this.getTaxaJuros()) / (1 - ((1 + this.getTaxaJuros()) ** (-quantidadeMeses))))
    this.rendaRiscoPrevidencia = resultado;
    this.changeRisco();
    return resultado;
  }
  calcularPrazoIndeterminado(): any {
    const idade = Math.floor(this.idadeAtual / 12);
    this.tabelaAtuaria.map((x: any) => {
      if (x.idade == idade) {
        let percentual = this.investimentoMensalPrevidencia / 100;
        this.tabuaAtuaria = this.sexo == 'AT2000M' ? x.AT2000M : x.AT2000F;
        this.rendaRiscoPrevidencia = this.investimentoMensalPrevidencia / this.tabuaAtuaria;
        this.changeRisco();
        this.rendaRiscoPrevidencia = (((this.montanteAcumulado * percentual) * this.getTaxaJuros()) / (1 - ((1 + this.getTaxaJuros()) ** -this.tabuaAtuaria)));
      }
    });
  }
  calcularPercentualSaldoConta() {
    let percentual = this.investimentoMensalPrevidencia / 100;
    this.rendaRiscoPrevidencia = ((this.montanteAcumulado * percentual) - this.saqueInicial) * (this.percentualSaldo / 100);
    this.changeRisco();
  }
  valorMaximo(prop: any) {
    this.changeRisco();
    if (((this.investimentoMensalMorte + this.investimentoMensalInvalidez) | 0) < 25) {
      this.investimentoMensalPrevidencia = this.formData.get('contribuicaoMensal')?.value * (0.75 + (Math.abs((this.investimentoMensalMorte + this.investimentoMensalInvalidez) - 25) / 100));
      this.investimentoMensalPrevidencia = this.montanteAcumulado * (0.75 + (Math.abs((this.investimentoMensalMorte + this.investimentoMensalInvalidez) - 25) / 100));
      this.simulacaoParalela();
    } else {
      this.investimentoMensalPrevidencia = this.montanteAcumulado * 0.75;
      this.investimentoMensalPrevidencia = this.formData.get('contribuicaoMensal')?.value * 0.75;
      this.simulacaoParalela();
    }
    // this.changeRisco(this.formData.get('contribuicaoMensal')?.value * 0.10);
  }
  simulacaoParalela() {
    if (this.formaRecebimento == 1) {
      this.calcularPercentualSaldoConta();
    } else if (this.formaRecebimento == 2) {
      this.calcularPrazoDeterminado();
    } else if (this.formaRecebimento == 3) {
      this.calcularPrazoIndeterminado();
    }
  }
  simular() {
    this.calcularData();
    if (this.chartFinal) {
      this.chartFinal.destroy();
    }
    if (this.chartAcumulado) {
      this.chartAcumulado.destroy();
    }
    if (!(this.tempo > 0)) {
      this.rendaRiscoPrevidencia = 0;
      this.rendaRiscoInvalidez = 0;
      this.rendaRiscoMorte = 0;
      return;
    }
    this.loading = true;
    if (this.checkboxRiscoMorte && this.investimentoMensalMorte == 0) {
      this.investimentoMensalMorte = this.formData.get('contribuicaoMensal')?.value * 0.15;
    }
    if (this.checkboxRiscoInvalidez && this.investimentoMensalInvalidez == 0) {
      this.investimentoMensalInvalidez = this.formData.get('contribuicaoMensal')?.value * 0.10;
    }
    let capital = this.formData.get('aporteInicial')?.value + this.formData.get('portabilidade')?.value;
    this.investimentoMensalPrevidencia = this.formData.get('contribuicaoMensal')?.value - this.investimentoMensalInvalidez - this.investimentoMensalMorte;
    this.montanteAcumulado = capital * ((1 + this.getTaxaJuros()) ** this.tempo) + (this.investimentoMensalPrevidencia * ((1 + this.getTaxaJuros()) ** this.tempo - 1)) / this.getTaxaJuros();
    setTimeout(async () => {
      this.simulacaoParalela();
    }, 2000);
    setTimeout(async () => {
      this.calcularJuros(capital, this.investimentoMensalPrevidencia, this.getTaxaJuros(), this.tempo - 1);
    }, 2000);
  }
  calcularJuros(montante: number, mensalidade: number, juro: number, prazo: number) {
    let bruto = montante;
    let liquido = montante;
    let labels: any[] = [];
    let brutos: any[] = [];
    let liquidos: any[] = [];
    let mes: number = new Date().getMonth();
    let ano: number = new Date().getFullYear();
    for (let loop = 1; loop <= prazo; loop++) {
      bruto += mensalidade;
      liquido = mensalidade * ((1 + juro) ** loop - 1) + (mensalidade * ((1 + juro) ** loop - 1)) / juro;
      mes++;
      if (mes >= 13) {
        mes = 1;
        ano++;
      }
      let data = mes + '/' + ano;
      labels.push(data);
      brutos.push(bruto);
      liquidos.push(liquido);
    }
    this.valorBruto = brutos[brutos.length - 1];
    this.valorTotal = liquidos[liquidos.length - 1];
    this.valorRendimentos = this.valorTotal - this.valorBruto;
    this.loading = false;
    if (this.chartFinal) {
      this.chartFinal.destroy();
    }
    if (this.chartAcumulado) {
      this.chartAcumulado.destroy();
    }
    this.chartAcumulado = new Chart('linechart', {
      type: 'line',
      data: {
        labels: labels,
        datasets: [{
          label: 'Valor Investido - R$',
          data: brutos,
          fill: true,
          borderColor: '#F46201',  // Verde escuro
          backgroundColor: 'rgba(244, 98, 1,0.2)',  // Verde claro (para a área preenchida)
          pointBackgroundColor: '#F46201',
          pointBorderColor: '#ffffff',
          pointRadius: 5,  // Tamanho dos pontos
          tension: 0.4,  // Tensão da linha para deixá-la mais suave
        }, {
          label: 'Valor com Rendimentos - R$',
          data: liquidos,
          fill: true,
          borderColor: '#1A428A',  // Azul escuro
          backgroundColor: 'rgba(26, 66, 138, 0.2)', // Azul claro (para a área preenchida)
          pointBackgroundColor: '#1A428A',  // Cor dos pontos da linha
          pointBorderColor: '#ffffff',  // Cor da borda dos pontos
          pointRadius: 5,
          tension: 0.4,
        }]
      },
      options: {
        responsive: true,  // Responsividade
        plugins: {
          legend: {
            display: false,
          },
          datalabels: {
            anchor: 'end',
            align: 'end',
            formatter: (value) => 'R$ ' + value.toFixed(2),  // Formatação para mostrar 2 casas decimais
            font: {
              weight: 'bold',
              size: 12
            },
            color: '#333'  // Cor dos rótulos
          }
        },
        scales: {
          x: {
            beginAtZero: true,
            grid: {
              display: false,  // Desativa a grid no eixo X para limpar a visualização
            },
            ticks: {
              font: {
                size: 12,
                weight: 'bold'
              },
              color: '#333'
            }
          },
          y: {
            beginAtZero: true,
            grid: {
              display: true,
              color: 'rgba(0, 0, 0, 0.1)'
            },
            ticks: {
              font: {
                size: 12,
                weight: 'bold'
              },
              color: '#333',
              callback: function (value: any) {
                // Formata o valor para o formato desejado (ex: "160 mil")
                return new Intl.NumberFormat('pt-BR', { style: 'decimal', notation: 'compact' }).format(value);
              }
            }
          }
        },
        layout: {
          padding: 20  // Ajuste o padding para deixar mais espaço ao redor do gráfico
        }
      }
    });
    this.chartFinal = new Chart('piechart', {
      type: 'pie',
      data: {
        labels: ['Valor Investido', 'Rendimentos'],
        datasets: [{
          label: 'R$',
          data: [this.valorBruto, this.valorRendimentos],
          borderWidth: 1,
          backgroundColor: ['#F46201', '#1A428A']
        }]
      },
      options: {
        responsive: true,
        plugins: {
          legend: {
            display: false,
          },
          datalabels: {
            anchor: 'end',
            align: 'end',
            formatter: (value) => {
              return Math.round((value / this.valorTotal) * 100) + '%';
            },
            font: {
              weight: 'bold',
              size: 12
            }
          }
        },
        layout: {
          padding: 30
        }
      }
    });
  }
  solicitar() {
    let checkbox = document.querySelector('#simulacaoAvancada') as HTMLInputElement;
    let [taxaMorte, taxaInvalidez] = this.consultaTaxa(new Date().getFullYear() - new Date(this.formData.get('dataNascimento')?.value).getFullYear());
    let valorMaximo = this.simulacaoCoberturaInvalidez > this.simulacaoCoberturaMorte ? ((3000 * taxaInvalidez) * 100) / 10 : ((3000 * taxaMorte) * 100) / 15;
    let valorMinimo = this.simulacaoCoberturaInvalidez < this.simulacaoCoberturaMorte ? 20 * taxaInvalidez : 20 * taxaMorte;
    if ((this.simulacaoCoberturaInvalidez < 20000 || this.simulacaoCoberturaInvalidez > 3000000) || (this.simulacaoCoberturaMorte < 20000 || this.simulacaoCoberturaMorte > 3000000)) {
      Swal.fire({
        title: 'Oooopss!!!',
        html: `Parece que o valor que você deseja investir mensalmente <b>excede o capital segurado máximo de Contratação para a sua faixa etária</b>, você precisa informar um valor de no <b>mínimo de ${this.formatarValor(valorMinimo)}</b> e no <b>máximo de ${this.formatarValor(valorMaximo)}</b>.`,
        confirmButtonText: "Continuar",
        cancelButtonText: "Ajustar Riscos",
        denyButtonText: `Calculo Automático`,
        confirmButtonColor: '#1A428A',
        denyButtonColor: '#FE7F2A'
      }).then(
        (result: any) => {
          if (result.isConfirmed) {
            console.log('Continuar');
          } else if (result.isDenied) {
            checkbox.checked = true;
            this.simulacaoAvancada(this);
          } else if (result.isDismissed) {
            checkbox.checked = true;
            this.simulacaoAvancada(this);
          }
        }
      )
    } else {
      Swal.fire({
        title: 'Atenção!!',
        html: `<p>Confirme os dados abaixo: </p><br>`,
        confirmButtonText: "Continuar",
        cancelButtonText: "Cancelar",
        confirmButtonColor: '#1A428A',
        denyButtonColor: '#FE7F2A'
      }).then(
        (result: any) => {
          if (result.isConfirmed) {
            console.log('Continuar');
          } else if (result.isDismissed) {
            console.log('Cancelar');
          }
        }
      )
    }
  }
  redirecionaAdesao() {
    this.toast.success("Redirecionado para o adesão!", "", { timeOut: 2000 });
  }
}
